import { Component, Input, OnInit } from '@angular/core';
import { UserAccessModel } from "../../shared/models/user-access.model";
import { NotificationModel } from "../../shared/models/notification.model";
import { Subscription } from "rxjs";
import { AuthService } from "../../shared/services/auth.service";
import { UserService } from "../../shared/services/user.service";

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit {

  @Input() user: UserAccessModel;
  lightTheme: boolean;
  notifications: NotificationModel[];
  isNotificationOpened = false;

  private notificationsSub: Subscription;

  constructor(private authService: AuthService, private userService: UserService) { }

  ngOnInit(): void {
    this.authService.lightTheme.subscribe(lightTheme => this.lightTheme = lightTheme);
    this.getNotifications();
  }

  ngOnDestroy(): void {
    if (this.notificationsSub) { this.notificationsSub.unsubscribe(); }
  }

  logout(): void {
    this.authService.logOut();
  }

  switchMode(): void {
    this.authService.switchMode(!this.lightTheme);
  }

  getNotifications(): void {
    if ( !this.user ) { return; }
    this.notificationsSub = this.userService.getNotifications(this.user.id).subscribe({
      next: (notifications: NotificationModel[]) => {
        this.notifications = notifications;
      }
    });
  }

  clickOutside(): void {
    if (this.isNotificationOpened) {
      this.isNotificationOpened = false;
    }
  }

}
